export const thesisSubmitMetadata = ['abstractCs', 'abstractEn', 'keywordsCs', 'keywordsEn'] as const
export const thesisSubmitData = [...thesisSubmitMetadata, 'attachments'] as const
